// extracted by mini-css-extract-plugin
export var animationContainer = "_hy-0";
export var asteriskIcon = "_hy-8";
export var conversationLeftSection = "_hy-4";
export var conversationListItem = "_hy-3";
export var conversationMiddleSection = "_hy-5";
export var conversationRightSection = "_hy-6";
export var detailsContent = "_hy-1";
export var listContainer = "_hy-7";
export var modalContent = "_hy-2";